import { render, staticRenderFns } from "./task-report-pannel.vue?vue&type=template&id=2307b8b2&scoped=true&"
import script from "./task-report-pannel.vue?vue&type=script&lang=js&"
export * from "./task-report-pannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2307b8b2",
  null
  
)

export default component.exports